export default function updateIsdCode() {
    // Get the two select elements
    const countrySelect = document.getElementById('country');
    const codeSelect = document.getElementById('isd-code');

    // Map countries to their respective country codes
    const countryCodeMap = {
      "Afghanistan": "+93",
      "Albania": "+355",
      "Algeria": "+213",
      "Andorra": "+376",
      "Angola": "+244",
      "Antigua and Barbuda": "+1-268",
      "Argentina": "+54",
      "Armenia": "+374",
      "Australia": "+61",
      "Austria": "+43",
      "Azerbaijan": "+994",
      "Bahamas": "+1-242",
      "Bahrain": "+973",
      "Bangladesh": "+880",
      "Barbados": "+1-246",
      "Belarus": "+375",
      "Belgium": "+32",
      "Belize": "+501",
      "Benin": "+229",
      "Bhutan": "+975",
      "Bolivia": "+591",
      "Bosnia and Herzegovina": "+387",
      "Botswana": "+267",
      "Brazil": "+55",
      "Brunei": "+673",
      "Bulgaria": "+359",
      "Burkina Faso": "+226",
      "Burundi": "+257",
      "Cabo Verde": "+238",
      "Cambodia": "+855",
      "Cameroon": "+237",
      "Canada": "+1",
      "Central African Republic": "+236",
      "Chile": "+56",
      "China": "+86",
      "Colombia": "+57",
      "Comoros": "+269",
      "Congo": "+242",
      "Costa Rica": "+506",
      "Croatia": "+385",
      "Cuba": "+53",
      "Cyprus": "+357",
      "Czech Republic": "+420",
      "Democratic Republic of the Congo": "+243",
      "Denmark": "+45",
      "Djibouti": "+253",
      "Dominica": "+1-767",
      "Dominican Republic": "+1-809",
      "Ecuador": "+593",
      "Egypt": "+20",
      "El Salvador": "+503",
      "Equatorial Guinea": "+240",
      "Eritrea": "+291",
      "Estonia": "+372",
      "Eswatini": "+268",
      "Ethiopia": "+251",
      "Fiji": "+679",
      "Finland": "+358",
      "France": "+33",
      "Gabon": "+241",
      "Gambia": "+220",
      "Georgia": "+995",
      "Germany": "+49",
      "Ghana": "+233",
      "Greece": "+30",
      "Grenada": "+1-473",
      "Guatemala": "+502",
      "Guinea": "+224",
      "Guinea-Bissau": "+245",
      "Guyana": "+592",
      "Haiti": "+509",
      "Honduras": "+504",
      "Hungary": "+36",
      "Iceland": "+354",
      "India": "+91",
      "Indonesia": "+62",
      "Iran": "+98",
      "Iraq": "+964",
      "Ireland": "+353",
      "Israel": "+972",
      "Italy": "+39",
      "Ivory Coast": "+225",
      "Jamaica": "+1-876",
      "Japan": "+81",
      "Jordan": "+962",
      "Kazakhstan": "+7",
      "Kenya": "+254",
      "Kiribati": "+686",
      "Kosovo": "+383",
      "Kuwait": "+965",
      "Kyrgyzstan": "+996",
      "Laos": "+856",
      "Latvia": "+371",
      "Lebanon": "+961",
      "Lesotho": "+266",
      "Liberia": "+231",
      "Libya": "+218",
      "Liechtenstein": "+423",
      "Lithuania": "+370",
      "Luxembourg": "+352",
      "Madagascar": "+261",
      "Malawi": "+265",
      "Malaysia": "+60",
      "Maldives": "+960",
      "Mali": "+223",
      "Malta": "+356",
      "Marshall Islands": "+692",
      "Mauritania": "+222",
      "Mauritius": "+230",
      "Mexico": "+52",
      "Micronesia": "+691",
      "Moldova": "+373",
      "Monaco": "+377",
      "Mongolia": "+976",
      "Montenegro": "+382",
      "Morocco": "+212",
      "Mozambique": "+258",
      "Myanmar": "+95",
      "Namibia": "+264",
      "Nauru": "+674",
      "Nepal": "+977",
      "Netherlands": "+31",
      "New Zealand": "+64",
      "Nicaragua": "+505",
      "Niger": "+227",
      "Nigeria": "+234",
      "North Korea": "+850",
      "North Macedonia": "+389",
      "Norway": "+47",
      "Oman": "+968",
      "Pakistan": "+92",
      "Palau": "+680",
      "Panama": "+507",
      "Papua New Guinea": "+675",
      "Paraguay": "+595",
      "Peru": "+51",
      "Philippines": "+63",
      "Poland": "+48",
      "Portugal": "+351",
      "Qatar": "+974",
      "Romania": "+40",
      "Russia": "+7",
      "Rwanda": "+250",
      "Saint Kitts and Nevis": "+1-869",
      "Saint Lucia": "+1-758",
      "Saint Vincent and the Grenadines": "+1-784",
      "Samoa": "+685",
      "San Marino": "+378",
      "Sao Tome and Principe": "+239",
      "Saudi Arabia": "+966",
      "Senegal": "+221",
      "Serbia": "+381",
      "Seychelles": "+248",
      "Sierra Leone": "+232",
      "Singapore": "+65",
      "Slovakia": "+421",
      "Slovenia": "+386",
      "Solomon Islands": "+677",
      "Somalia": "+252",
      "South Africa": "+27",
      "South Korea": "+82",
      "South Sudan": "+211",
      "Spain": "+34",
      "Sri Lanka": "+94",
      "Sudan": "+249",
      "Suriname": "+597",
      "Sweden": "+46",
      "Switzerland": "+41",
      "Syria": "+963",
      "Taiwan": "+886",
      "Tajikistan": "+992",
      "Tanzania": "+255",
      "Thailand": "+66",
      "Timor-Leste": "+670",
      "Togo": "+228",
      "Tonga": "+676",
      "Trinidad and Tobago": "+1-868",
      "Tunisia": "+216",
      "Turkmenistan": "+993",
      "Turkey": "+90",
      "Tuvalu": "+688",
      "Uganda": "+256",
      "Ukraine": "+380",
      "United Arab Emirates": "+971",
      "United Kingdom": "+44",
      "United States": "+1",
      "Uruguay": "+598",
      "Uzbekistan": "+998",
      "Vanuatu": "+678",
      "Venezuela": "+58",
      "Vietnam": "+84",
      "Yemen": "+967",
      "Zambia": "+260",
      "Zimbabwe": "+263"
  };

  const swappedCountryCodeMap = {
  "+93": "Afghanistan",
  "+355": "Albania",
  "+213": "Algeria",
  "+376": "Andorra",
  "+244": "Angola",
  "+1-268": "Antigua and Barbuda",
  "+54": "Argentina",
  "+374": "Armenia",
  "+61": "Australia",
  "+43": "Austria",
  "+994": "Azerbaijan",
  "+1-242": "Bahamas",
  "+973": "Bahrain",
  "+880": "Bangladesh",
  "+1-246": "Barbados",
  "+375": "Belarus",
  "+32": "Belgium",
  "+501": "Belize",
  "+229": "Benin",
  "+975": "Bhutan",
  "+591": "Bolivia",
  "+387": "Bosnia and Herzegovina",
  "+267": "Botswana",
  "+55": "Brazil",
  "+673": "Brunei",
  "+359": "Bulgaria",
  "+226": "Burkina Faso",
  "+257": "Burundi",
  "+238": "Cabo Verde",
  "+855": "Cambodia",
  "+237": "Cameroon",
  "+1": "Canada",
  "+236": "Central African Republic",
  "+56": "Chile",
  "+86": "China",
  "+57": "Colombia",
  "+269": "Comoros",
  "+242": "Congo",
  "+506": "Costa Rica",
  "+385": "Croatia",
  "+53": "Cuba",
  "+357": "Cyprus",
  "+420": "Czech Republic",
  "+243": "Democratic Republic of the Congo",
  "+45": "Denmark",
  "+253": "Djibouti",
  "+1-767": "Dominica",
  "+1-809": "Dominican Republic",
  "+593": "Ecuador",
  "+20": "Egypt",
  "+503": "El Salvador",
  "+240": "Equatorial Guinea",
  "+291": "Eritrea",
  "+372": "Estonia",
  "+268": "Eswatini",
  "+251": "Ethiopia",
  "+679": "Fiji",
  "+358": "Finland",
  "+33": "France",
  "+241": "Gabon",
  "+220": "Gambia",
  "+995": "Georgia",
  "+49": "Germany",
  "+233": "Ghana",
  "+30": "Greece",
  "+1-473": "Grenada",
  "+502": "Guatemala",
  "+224": "Guinea",
  "+245": "Guinea-Bissau",
  "+592": "Guyana",
  "+509": "Haiti",
  "+504": "Honduras",
  "+36": "Hungary",
  "+354": "Iceland",
  "+91": "India",
  "+62": "Indonesia",
  "+98": "Iran",
  "+964": "Iraq",
  "+353": "Ireland",
  "+972": "Israel",
  "+39": "Italy",
  "+225": "Ivory Coast",
  "+1-876": "Jamaica",
  "+81": "Japan",
  "+962": "Jordan",
  "+7": "Kazakhstan",
  "+254": "Kenya",
  "+686": "Kiribati",
  "+383": "Kosovo",
  "+965": "Kuwait",
  "+996": "Kyrgyzstan",
  "+856": "Laos",
  "+371": "Latvia",
  "+961": "Lebanon",
  "+266": "Lesotho",
  "+231": "Liberia",
  "+218": "Libya",
  "+423": "Liechtenstein",
  "+370": "Lithuania",
  "+352": "Luxembourg",
  "+261": "Madagascar",
  "+265": "Malawi",
  "+60": "Malaysia",
  "+960": "Maldives",
  "+223": "Mali",
  "+356": "Malta",
  "+692": "Marshall Islands",
  "+222": "Mauritania",
  "+230": "Mauritius",
  "+52": "Mexico",
  "+691": "Micronesia",
  "+373": "Moldova",
  "+377": "Monaco",
  "+976": "Mongolia",
  "+382": "Montenegro",
  "+212": "Morocco",
  "+258": "Mozambique",
  "+95": "Myanmar",
  "+264": "Namibia",
  "+674": "Nauru",
  "+977": "Nepal",
  "+31": "Netherlands",
  "+64": "New Zealand",
  "+505": "Nicaragua",
  "+227": "Niger",
  "+234": "Nigeria",
  "+850": "North Korea",
  "+389": "North Macedonia",
  "+47": "Norway",
  "+968": "Oman",
  "+92": "Pakistan",
  "+680": "Palau",
  "+507": "Panama",
  "+675": "Papua New Guinea",
  "+595": "Paraguay",
  "+51": "Peru",
  "+63": "Philippines",
  "+48": "Poland",
  "+351": "Portugal",
  "+974": "Qatar",
  "+40": "Romania",
  "+7": "Russia",
  "+250": "Rwanda",
  "+1-869": "Saint Kitts and Nevis",
  "+1-758": "Saint Lucia",
  "+1-784": "Saint Vincent and the Grenadines",
  "+685": "Samoa",
  "+378": "San Marino",
  "+239": "Sao Tome and Principe",
  "+966": "Saudi Arabia",
  "+221": "Senegal",
  "+381": "Serbia",
  "+248": "Seychelles",
  "+232": "Sierra Leone",
  "+65": "Singapore",
  "+421": "Slovakia",
  "+386": "Slovenia",
  "+677": "Solomon Islands",
  "+252": "Somalia",
  "+27": "South Africa",
  "+82": "South Korea",
  "+211": "South Sudan",
  "+34": "Spain",
  "+94": "Sri Lanka",
  "+249": "Sudan",
  "+597": "Suriname",
  "+46": "Sweden",
  "+41": "Switzerland",
  "+963": "Syria",
  "+886": "Taiwan",
  "+992": "Tajikistan",
  "+255": "Tanzania",
  "+66": "Thailand",
  "+670": "Timor-Leste",
  "+228": "Togo",
  "+676": "Tonga",
  "+1-868": "Trinidad and Tobago",
  "+216": "Tunisia",
  "+993": "Turkmenistan",
  "+90": "Turkey",
  "+688": "Tuvalu",
  "+256": "Uganda",
  "+380": "Ukraine",
  "+971": "United Arab Emirates",
  "+44": "United Kingdom",
  "+1": "United States",
  "+598": "Uruguay",
  "+998": "Uzbekistan",
  "+678": "Vanuatu",
  "+58": "Venezuela",
  "+84": "Vietnam",
  "+967": "Yemen",
  "+260": "Zambia",
  "+263": "Zimbabwe"
};


    // Function to update the country code based on the country selected
    function updateCountryCode() {
      const country = countrySelect.value;
      // Update the second select element to match the country code
      codeSelect.value = countryCodeMap[country] || ''; // Default to empty if no match
      console.log(countryCodeMap[country])   
    }

    function updateCountry() {
      const countryCode = codeSelect.value;
      // Update the second select element to match the country code
      countrySelect.value = swappedCountryCodeMap[countryCode] || ''; // Default to empty if no match   
    }

    // Listen for changes on the country select element
    countrySelect.addEventListener('change', updateCountryCode);
    codeSelect.addEventListener('change', updateCountry);

}

